interface Stakeholder {
  first_name: string,
  last_name: string,
  address?: string,
  city?: string,
  state?: string,
  postal_code: string,
  phone?: string,
  email?: string,
  longitude: string,
  latitude: string
}

interface ResponseJSON {
  [key: string]: string[] | string | number
}

interface SurveyMetadata {
  meta_data: string[]
}

interface SurveyResponse {
  comment_location: string[],
  response_json: ResponseJSON,
  survey: number,
  survey_taker_id: number,
  timestamp: string,
  survey_metadata: SurveyMetadata
}

interface MarkerSymbol {
  type: string,
  url: string,
  width: number,
  height: number
}


export const stakeholderLabels: Function = (stakeholder: Stakeholder): string => {
  // const address = stakeholder.address || stakeholder.address?.length !== 0 ? stakeholder.address : "";
  // we will only be able to use `nullish coalescing` ?? operator for NULL values, if values default to "", we must use the code above

  const address = stakeholder.address ?? "";
  const city = stakeholder.city ?? "";
  const state = stakeholder.state ?? "";
  const email = stakeholder.email ?? "None provided";
  const phone = stakeholder.phone ?? "None provided";

  return `<strong>Name:</strong>
        ${stakeholder.first_name} ${stakeholder.last_name} 
        <br>
        <strong> Address: </strong>
        ${address}
        ${city}
        ${state}
        ${stakeholder.postal_code}
        <br>
        <strong> Email: </strong>${email}
        <br>
        <strong> Phone: </strong>${phone}
        <br><br>`;
};

const getQuestionText: Function = (question: any, response: SurveyResponse): string => {
  return response.survey_metadata.meta_data[question]
}

export const surveyLabels: Function = (response: SurveyResponse): string => {
  const arr = []
  for (let [question, answer] of Object.entries(response.response_json)) {
    arr.push(`<strong> ${getQuestionText(question, response)}: </strong> <br>${answer} <br><br>`);
  }
  return arr.join(' ')
};

// const formatFavorability = favorability => {
//   switch (favorability) {
//   case 1:
//     return "Not worried at all";
//   case 2:
//     return "Somewhat worried";
//   case 3:
//     return "No position";
//   case 4:
//     return "Not very worried";
//   case 5:
//     return "Very worried";
//   }
// };

// const formatWorry = worry => {
//   switch (worry) {
//   case 1:
//     return "Not worried at all";
//   case 2:
//     return "Somewhat worried";
//   case 3:
//     return "No position";
//   case 4:
//     return "Not very worried";
//   case 5:
//     return "Very worried";
//   }
// };

const baseMarker : MarkerSymbol = {
  type: "picture-marker",
  url: "",
  width: 24,
  height: 24
};

export const getMarkerSymbol: Function = (url: string): MarkerSymbol => ({ ...baseMarker, url: url });

